//// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {

    export interface IGisQueryGridScope extends angular.IScope {
        queryGridOverride: Wars.Domain.Model.Gis.QueryGridOverride;
        runQueries: any;
        combinedResults: any[];
        zoomToRow: any;
    }

    export class GisQueryGrid implements IDirective {
        constructor() {

        }

        public templateUrl = "./app/views/directives/gis/gisQueryGrid.html";
        public restrict: string = "E";
        public controller = ["$scope", 'esriMapService', '$q', 'gisDatastoreService', GisQueryGridController];
        public controllerAs = "controller";
        public scope: any = {
            queryGridOverride: "="
        };

        public link($scope: IApiGridScope, element: JQuery, attrs: ng.IAttributes) {

        }

    }

    export class GisQueryGridController {
        public layer: L.GeoJSON;

        constructor(private $scope: IGisQueryGridScope,
            private esriMapService: services.EsriMapService,
            private $q: angular.IQService,
            private gisDatastoreService: services.GisDatastoreService) {

            this.$scope.runQueries = () => this.runQueries();
            this.$scope.zoomToRow = (f) => this.zoomToRow(f);
            if ($scope.queryGridOverride.queryGridConfiguration) {
                if ($scope.queryGridOverride.queryGridConfiguration.runQueryOnLoad) {
                    this.runQueries();
                }
            }

            if ($scope.queryGridOverride.includedMapFunction) {
                $scope.$on($scope.queryGridOverride.includedMapFunction.mapFunctionConfiguration_id,
                    (e, input) => {
                        this.runQueries(input);
                    });
            }

            if ($scope.queryGridOverride.placeHolderValues) {
                $scope.queryGridOverride.placeHolderValues.forEach(v => {
                    $scope.$on(v.includedMapFunction.mapFunctionConfiguration_id,
                        (e, input) => {
                            this.runQueries(input, v.placeHolderUniqueIdentifier);
                        });
                });
            }
        }

        public zoomToRow(row) {
            let feature = row.feature;
            let geojson = L.geoJSON(feature);

            GisMapController.currentMap.fitBounds(geojson.getBounds());
        }

        private onEachFeature(feature, layer) {
            if (feature.popup) {
                layer.bindPopup(feature.popup);
            }
        }

        public runQueries(input?: any, placeHolderId?: string) {
            this.$scope.combinedResults = [];
            var placeholderDict = {};
            let placeHolderGeo = null;

            if (this.layer) {
                warsApp.directives.GisMapController.currentMap.removeLayer(this.layer);
            }

            if (input && input.textValue) {
                placeholderDict[placeHolderId] = input.textValue;
            }

            if (input && input.geometry) {
                placeHolderGeo = input.geometry;
            }

            var options: any = this.$scope.queryGridOverride.queryGridConfiguration.drawStyle;

            if (this.$scope.queryGridOverride.queryGridConfiguration.drawStyle.markerColor) {
                let color = null;

                switch (this.$scope.queryGridOverride.queryGridConfiguration.drawStyle.markerColor) {
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Blue:
                    color = "blue";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Red:
                    color = "red";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Green:
                    color = "green";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Orange:
                    color = "orange";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Yellow:
                    color = "yellow";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Violet:
                    color = "violet";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Grey:
                    color = "grey";
                    break;
                case Wars.Domain.Model.Codes.Enums.MarkerColor.Black:
                    color = "black";
                    break;

                default:
                }
                let iconUrl = `./marker-icon-2x-${color}.png`;
                L.Icon.Default.mergeOptions({
                    iconUrl: iconUrl
                });
                options.icon = new L.Icon({
                    iconUrl: iconUrl,
                    shadowUrl: '/content/images/marker-shadow.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });
            }

            if (Enumerable.from(this.$scope.queryGridOverride.queryGridConfiguration.includedQueryFields)
                .any(f => f.showInPopup)) {
                (<any>options).onEachFeature = this.onEachFeature;
            }

            if (this.$scope.queryGridOverride.queryGridConfiguration.addResultsToMap) {
                this.layer = L.geoJSON(null, options);

                this.layer.addTo(warsApp.directives.GisMapController.currentMap);
            }

            this.$scope.queryGridOverride.queryGridConfiguration.queryGridQueries.forEach(q => {
                if (q.esriQueryConfiguration) {
                    if (this.$scope.queryGridOverride.excludeNullPlaceholders &&  !placeHolderGeo &&
                        q.esriQueryConfiguration.includeGeometryFilter && !q.esriQueryConfiguration.geometryFilter.useMapGeometry) {
                        return;
                    }

                    if (this.$scope.queryGridOverride.excludeNullPlaceholders && input && !input.textValue &&
                        q.esriQueryConfiguration.wherePredicates && Enumerable.from(q.esriQueryConfiguration.wherePredicates).any(p=>p.isPlaceholder)) {
                        return;
                    }

                    if (placeHolderId && !Enumerable.from(q.esriQueryConfiguration.wherePredicates)
                        .any(w => w.placeHolderUniqueIdentifier === placeHolderId)) {
                        return;
                    }

                    if (q.esriQueryConfiguration.wherePredicates) {
                        q.esriQueryConfiguration.wherePredicates.forEach(w => {
                            if (w.placeHolderUniqueIdentifier === placeHolderId) {
                                placeholderDict[w.field.name] = input.textValue;
                            }
                        });
                    }


                    this.esriMapService.queryMapService(q.esriQueryConfiguration, placeholderDict, placeHolderGeo).then(
                        results => {
                            let tempResult = [];

                            results.features.forEach(f => {
                                let tempRow = {};
                                let popUpRows = "";

                                q.gisFieldMappings.forEach(fieldMapping => {
                                    let value = f.properties[fieldMapping.esriField.name];
                                    //Hack: This should probably use the actual field type
                                    if ((fieldMapping.esriField.name.toUpperCase().indexOf("DATE") >= 0 ||
                                        fieldMapping.esriField.name.toUpperCase().indexOf("_DT") >= 0) && typeof value == "number") {
                                        value = new Date(value).toLocaleDateString('en-US');
                                    }

                                    if (fieldMapping.javascriptTransformer) {
                                        let args = ['value', fieldMapping.javascriptTransformer.code];
                                        let myFunc = Function.apply(null, args);

                                        value = myFunc(value);
                                    }
                                    if (fieldMapping.includedQueryField.showInPopup) {
                                        popUpRows += `<tr><td>${fieldMapping.includedQueryField
                                            .name}:</td><td>${value}</td></tr>`;
                                    }

                                    tempRow[fieldMapping.includedQueryField.uniqueId] = value;
                                });

                                if (popUpRows !== "") {
                                    f.popup = `<table>${popUpRows}</table>`;
                                }

                                (<any>tempRow).feature = f;

                                tempResult.push(tempRow);

                            });

                            this.$scope.combinedResults.addRange(tempResult);

                            this.$scope.queryGridOverride.queryGridConfiguration.includedQueryFields.forEach(
                                fieldMapping => {
                                    if (fieldMapping.distictOnField) {
                                        this.$scope.combinedResults =
                                            Enumerable.from(this.$scope.combinedResults)
                                            .distinct(item => item[fieldMapping.uniqueId]).toArray();
                                    }
                                });

                            this.layer.addData(results);

                            console.log(this.$scope.combinedResults);
                        });
                } else if (q.gisDatastoreQueryConfiguration) {
                    if (this.$scope.queryGridOverride.excludeNullPlaceholders &&  !placeHolderGeo &&
                        q.gisDatastoreQueryConfiguration.includeGeometryFilter && !q.gisDatastoreQueryConfiguration.geometryFilter.useMapGeometry) {
                        return;
                    }
                    
                    if (this.$scope.queryGridOverride.excludeNullPlaceholders &&  input && !input.textValue &&
                        q.gisDatastoreQueryConfiguration.wherePredicates && Enumerable.from(q.gisDatastoreQueryConfiguration.wherePredicates).any(p=>p.isPlaceholder)) {
                        return;
                    }

                    if (placeHolderId && !Enumerable.from(q.gisDatastoreQueryConfiguration.wherePredicates)
                        .any(w => w.placeHolderUniqueIdentifier === placeHolderId)) {
                        return;
                    }

                    if (q.gisDatastoreQueryConfiguration.wherePredicates) {
                        q.gisDatastoreQueryConfiguration.wherePredicates.forEach(w => {
                            if (w.placeHolderUniqueIdentifier === placeHolderId) {
                                placeholderDict[`Metadata${w.metadataNumber}`] = input.textValue;
                            }
                        });
                    }

                    if (q.gisDatastoreQueryConfiguration.geometryFilter &&
                        q.gisDatastoreQueryConfiguration.geometryFilter.useMapGeometry) {
                        var bounds = warsApp.directives.GisMapController.currentMap.getBounds();

                        let coords = [
                            [
                                [bounds.getSouth(), bounds.getWest()],
                                [bounds.getNorth(), bounds.getWest()],
                                [bounds.getNorth(), bounds.getEast()],
                                [bounds.getSouth(), bounds.getEast()],
                                [bounds.getSouth(), bounds.getWest()]
                            ]
                        ];

                        placeHolderGeo = {
                            type: "Feature",
                            properties: {},
                            geometry: {
                                "type": "Polygon",
                                "coordinates": coords
                            }
                        };
                    }

                    this.gisDatastoreService
                        .queryGisDatastore(q.gisDatastoreQueryConfiguration.gisDatastore,
                            placeholderDict,
                            q.gisDatastoreQueryConfiguration,
                            placeHolderGeo)
                        .then(
                            features => {

                                let tempResult = [];
                                let geoJsonFeatures = [];

                                features.forEach(f => {
                                    let tempRow = {};
                                    let popUpRows = "";
                                    let parsedGeoJson = JSON.parse(f.geoJson);


                                    q.gisFieldMappings.forEach(fieldMapping => {
                                        let value = f['metadata' + fieldMapping.metadataPosition];
                                        if (fieldMapping.includedQueryField.showInPopup) {
                                            popUpRows += `<tr><td>${fieldMapping.includedQueryField
                                                .name}:</td><td>${value}</td></tr>`;
                                        }

                                        if (fieldMapping.javascriptTransformer) {
                                            let args = ['value', fieldMapping.javascriptTransformer.code];
                                            let myFunc = Function.apply(null, args);

                                            value = myFunc(value);
                                        }

                                        tempRow[fieldMapping.includedQueryField.uniqueId] = value;
                                    });

                                    if (popUpRows !== "") {
                                        parsedGeoJson.popup = `<table>${popUpRows}</table>`;
                                    }

                                    (<any>tempRow).feature = parsedGeoJson;
                                    geoJsonFeatures.push(parsedGeoJson);

                                    tempResult.push(tempRow);

                                });

                                const featureCollection = {
                                    features: geoJsonFeatures,
                                    type: 'FeatureCollection'
                                };

                                this.$scope.combinedResults.addRange(tempResult);
                                this.layer.addData(<any>featureCollection);

                                this.$scope.queryGridOverride.queryGridConfiguration.includedQueryFields.forEach(
                                    fieldMapping => {
                                        if (fieldMapping.distictOnField) {
                                            this.$scope.combinedResults =
                                                Enumerable.from(this.$scope.combinedResults)
                                                .distinct(item => item[fieldMapping.uniqueId]).toArray();
                                        }
                                    });

                                console.log(this.$scope.combinedResults);
                            });
                }
            });
        }

    }
}

warsApp.registerDirective('GisQueryGrid', []);